export default __webpack_public_path__ + "static/Dialogs-d964ce51e0360671f1b7ae028af3519d.png";